// 日志级别
export enum LogLevel {
  DEBUG = 'debug',
  INFO = 'info',
  WARN = 'warn',
  ERROR = 'error'
}

// 错误类型
export enum ErrorType {
  NETWORK = 'network',
  TIMEOUT = 'timeout',
  PARSE = 'parse',
  TOKENIZE = 'tokenize',
  TRANSLATE = 'translate',
  CONVERT = 'convert',
  UNKNOWN = 'unknown'
}

// 翻译服务类型
export enum TranslateService {
  Google = 'google',
  M2M100 = 'm2m100'
}

// 自定义错误类
export class JapaneseServiceError extends Error {
  type: ErrorType;
  details?: any;

  constructor(message: string, type: ErrorType = ErrorType.UNKNOWN, details?: any) {
    super(message);
    this.name = 'JapaneseServiceError';
    this.type = type;
    this.details = details;
  }
}

// 汉字信息
export interface KanjiInfo {
  kanji: string;     // 汉字
  reading: string;   // 假名读音
}

// 单词信息
export interface WordInfo {
  text: string;      // 显示的文字
  isKanjiWord: boolean; // 是否是汉字词
  kanjis: KanjiInfo[];  // 每个汉字的读音信息
  romaji: string;    // 罗马音
  error?: boolean;   // 添加错误标记
  audio?: string;    // 添加音频 URL

  // 添加 kuromoji 分词信息
  pos?: string;      // 品詞 (词性)
  pos_detail_1?: string; // 品詞細分類1
  pos_detail_2?: string; // 品詞細分類2
  pos_detail_3?: string; // 品詞細分類3
  conjugated_type?: string; // 活用型
  conjugated_form?: string; // 活用形
  basic_form?: string;     // 基本形
  reading?: string;        // 読み
  pronunciation?: string;  // 発音
}

// 字符映射
export interface CharacterMapping {
  character: string;
  romaji: string;
  isKanji: boolean;
}

// 分词段映射
export interface SegmentMapping {
  segment: string;
  reading: string;
  romaji: string;
  characters: CharacterMapping[];
}

// 重新导出JapaneseConfig
export type { JapaneseConfig } from '../../types/config';

// 进度回调函数类型
export type ProgressCallback = (progress: number, message: string) => void;

// 谷歌翻译响应类型
export interface GoogleTranslateResponse extends Array<Array<Array<string>>> {}

// M2M100翻译响应类型
export interface M2M100Response {
  text: string;
}

// 注释结果
export interface AnnotationResult {
  japaneseText: string;
  annotation: {
    segments: string[];
    readings: string[];
    romaji: string[];
  };
  formattedAnnotation: string;
}

// 缓存条目
export interface CacheEntry<T> {
  value: T;
  timestamp: number;
  accessCount: number;
  lastAccessed: number;
}

// 缓存配置
export interface CacheConfig {
  maxSize: number;
  ttl: number; // 生存时间（毫秒）
}